module.exports = __webpack_public_path__ + "img/avatar.e058099f.png";